import React from 'react';
import { ShieldCheck, Truck, Award, Layers } from 'lucide-react';

const ITEMS = [
  { icon: Award,       t: 'MASTER INSTALLER LABOR',        s: '15+ yrs · 3M + Avery certified' },
  { icon: ShieldCheck, t: 'ZERO-FAILURE GUARANTEE',        s: 'Edge-lift · bubble · flip · covered' },
  { icon: Truck,       t: 'BLIND-SHIP FULFILLMENT',        s: 'Unmarked · your brand · your invoice' },
  { icon: Layers,      t: 'PREMIUM CAST MEDIA ONLY',       s: '3M 2080 · Avery MPI 1105 · Orafol 970' },
];

export default function GuaranteeBar() {
  return (
    <section className="relative bg-[#0A0A0A] border-b mi-line-strong">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 grid grid-cols-2 md:grid-cols-4 gap-4">
        {ITEMS.map((it, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="w-10 h-10 border mi-line-strong grid place-items-center flex-shrink-0">
              <it.icon className="w-5 h-5 text-[#E63946]" strokeWidth={1.5} />
            </div>
            <div className="min-w-0">
              <div className="mi-eyebrow text-white text-[10px]">{it.t}</div>
              <div className="text-white/55 text-xs mt-0.5 leading-snug">{it.s}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
